module.exports = __webpack_public_path__ + "img/crossroad.0d0ecdfc.svg";